import { render, staticRenderFns } from "./GoToCheckoutModal.vue?vue&type=template&id=661727b3&"
import script from "./GoToCheckoutModal.vue?vue&type=script&lang=js&"
export * from "./GoToCheckoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports